<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
import { clone, filter, isEqual, values } from 'lodash'

export default {
  name: 'SingleSelectInput',
  props: {
    showSearch: Boolean,
    items: Array,
    label: String,
    vid: String,
    placeholder: String,
    itemKey: {
      type: String,
      default: 'key',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    result: {
      type: Object,
      default: _ => {},
    },
    required: Boolean,
    defaultOption: {
      type: Object,
      default: _ => {},
    },
  },
  data() {
    return {
      errors: null,
      res: null,
      search: '',
      closeContent: true,
      openList: false,
    }
  },
  computed: {
    searchItems() {
      if (this.showSearch) {
        return filter(this.items, i => {
          return i[this.itemValue].toLowerCase().includes(this.search)
        })
      } else {
        return this.items
      }
    },
    isRes() {
      return values(this.result)[0] !== undefined
    },
  },
  watch: {
    result: {
      handler() {
        this.res = clone(this.result)
      },
      immediate: true,
    },
  },
  mounted() {
    this.$watch(
      () => {
        if (this.$refs.validator) {
          return this.$refs.validator.errors
        }
      },
      value => {
        this.errors = value
      },
    )
    if (this.defaultOption) {
      this.toggleItem(this.defaultOption)
    } else if ((this.result && values(this.result)[0] !== undefined) || !this.required) {
      this.$refs.validator.syncValue(this.result)
      this.$refs.validator.setFlags({
        pristine: true,
        touched: false,
        untouched: true,
        valid: true,
      })
    }
  },
  methods: {
    isItemActive(item) {
      return !!isEqual(this.result, item)
    },
    toggleItem(item) {
      if (!this.isItemActive(item)) {
        this.$refs.validator.syncValue(item)
      } else {
        this.$refs.validator.syncValue(null)
      }
      this.$refs.validator.validate().then(_ => {
        this.$refs.validator.setFlags({
          dirty: true,
          pristine: false,
          touched: true,
          untouched: false,
        })

        if (this.$refs.validator.flags.valid && this.$refs.validator.flags.touched && !this.isItemActive(item)) {
          this.res = clone(item)
          this.$emit('resultUpdated', this.res)
        } else {
          this.removeItem()
        }
      })
    },
    removeItem() {
      this.res = null
      this.$emit('resultUpdated', this.res)
    },
  },
}
</script>
